export default {
    path: '/campaign-settings/:campaignId/manage-users',
    preload: false,
    middlewares: [
        {
            "rms_ui/validatePermissionsMiddleware": [
                ["rms.campaign_admin", "rms.owner_user_admin"],
                "/login"
            ]
        }
    ]
}
